<template lang="pug">
  div(
    :id="'av-van-cart-' + timestamp"
    :class="[$style.avTruckCart, $style.vanStill]"
    :style="'font-size:' + size + 'px;'")
    div(:class="$style.counter") {{ counter }}
    div(:class="$style.shockwave")
    svg(
      :class="$style.truckBody"
      width="77"
      height="42"
      viewBox="0 0 78 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg")
      path(
        d="M49.2506 27.4856C49.2506 29.6947 47.4597 31.4856 45.2506 31.4856H4.60193C2.39279 31.4856 0.601929 33.2764 0.601929 35.4856V38.2964C0.601929 40.5055 2.39279 42.2964 4.60192 42.2964H73.629C75.8381 42.2964 77.629 40.5055 77.629 38.2964V24.647C77.629 23.8209 77.3732 23.0151 76.8968 22.3403L62.608 2.09775C61.8585 1.03594 60.6398 0.40448 59.3401 0.40448H53.2506C51.0414 0.40448 49.2506 2.19535 49.2506 4.40448V27.4856Z"
        fill="#41A5DD")
      path(
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.45563 2.40448C0.455628 1.29991 1.35106 0.404483 2.45563 0.404482V0.404482C3.5602 0.404481 4.45563 1.29991 4.45563 2.40448L4.45565 19.2094C4.45565 21.4185 6.24652 23.2094 8.45565 23.2094H36.7605C38.9697 23.2094 40.7605 21.4185 40.7605 19.2094V2.40542C40.7605 1.30085 41.656 0.40542 42.7605 0.40542V0.40542C43.8651 0.40542 44.7605 1.30085 44.7605 2.40542V23.2094C44.7605 25.4185 42.9697 27.2094 40.7605 27.2094H4.45565C2.24651 27.2094 0.455654 25.4185 0.455652 23.2094L0.45563 2.40448Z"
        fill="#B1E3FF")
    svg(
      :class="$style.truckWheels"
      width="69"
      height="20"
      viewBox="0 0 70 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg")
      path(
        d="M67.5017 10.8649C67.5017 15.3578 63.8595 19 59.3666 19C54.8737 19 51.2315 15.3578 51.2315 10.8649C51.2315 6.37196 54.8737 2.72974 59.3666 2.72974C63.8595 2.72974 67.5017 6.37196 67.5017 10.8649ZM18.8531 10.8649C18.8531 15.3578 15.2109 19 10.718 19C6.22505 19 2.58282 15.3578 2.58282 10.8649C2.58282 6.37196 6.22505 2.72974 10.718 2.72974C15.2109 2.72974 18.8531 6.37196 18.8531 10.8649Z"
        fill="white"
        stroke="#636363"
        stroke-width="4")
</template>

<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({
  name: "AnyVanAnimatedVanIcon",
  props: {
    counter: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      timestamp: new Date().getTime()
    }
  },
  computed: {
    van() {
      // @ts-ignore
      return document.querySelector("#av-van-cart-" + this.timestamp)
    }
  },
  methods: {
    vanPulse() {
      // @ts-ignore
      this.van.setAttribute("class", this.$style.avTruckCart + " " + this.$style.vanPulse)
    },
    vanReset() {
      // @ts-ignore
      this.van.setAttribute("class", this.$style.avTruckCart + " " + this.$style.vanStill)
    }
  },
  watch: {
    counter: {
      handler(newVal, oldVal) {
        if (newVal > oldVal) {
          this.vanReset()

          setTimeout(() => {
            this.vanPulse()
          }, 1)
        }
      }
    }
  }
})
</script>

<style lang="css" module>
.avTruckCart {
  position: relative;
  height: 1em;
  width: auto;
  display: inline-block;
}

.truckBody {
  position: relative;
  height: 0.8em;
  width: auto;
  vertical-align: top;
  animation-timing-function: ease-out;
}

.truckWheels {
  position: absolute;
  height: 0.38em;
  width: auto;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.vanStill .truckBody {
  transform: translate3d(0, 0, 0);
}

.vanPulse .truckBody {
  animation: 1s ease-in-out van-pulse-anim;
}

@keyframes van-pulse-anim {
  0% {
    transform: translate3d(0, 0, 0);
  }
  5% {
    transform: translate3d(0, 20%, 0);
  }
  25% {
    transform: translate3d(0, -5%, 0);
  }
  45% {
    transform: translate3d(0, 10%, 0);
  }
  60% {
    transform: translate3d(0, 0, 0);
  }
  80% {
    transform: translate3d(0, 5%, 0);
  }
  100% {
    transform: translate3d(0, 0%, 0);
  }
}

.shockwave {
  position: absolute;
  width: 40%;
  height: 0;
  top: -10%;
  left: 9%;
  padding-bottom: 40%;
  outline: 0.1em solid rgba(255, 0, 0, 0.5);
  z-index: 12;
  border-radius: 50%;
  pointer-events: none;
}

.vanStill .shockwave {
  transform: scale3d(1, 1, 1);
  opacity: 0;
}

.vanPulse .shockwave {
  animation: 0.75s ease-out forwards van-shockwave-anim;
}

@keyframes van-shockwave-anim {
  0% {
    transform: scale3d(1, 1, 1);
    opacity: 0.8;
  }
  100% {
    transform: scale3d(10, 10, 1);
    opacity: 0;
    outline-width: 1px;
  }
}

.counter {
  position: absolute;
  font-size: 0.5em;
  width: 1.7em;
  text-align: center;
  line-height: normal;
  top: -0.3em;
}
</style>
